<template>
    <div class="audio-wrap">
        <i class="stop"
           @click="play_audio(ask)"
           v-show="isPlay"></i>
        <i class="play"
           @click="pause_audio"
           v-show="!isPlay"></i>
        <div class="all-audio"
             :id="'audio_all'+ask.id">
            <aside class="has-audio"
                   :id="'audio_now'+ask.id"
                   :style="audioWidth"></aside>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
export default {
    data () {
        return {
            curTime: 0,//已听时长
            allTime: 1,//总时长
            isPlay: true,
            finish: true,//是否在暂停状态
            Speed: 1,//步长
            speed_time: null,  //播放进度定时器
        }
    },
    props: ['ask', 'sid'],
    components: {},
    computed: {
        audioWidth () {
            return {
                width: (this.curTime / this.allTime) * 100 + '%'
            }
        },
    },
    destroyed () {
        // try {
        //   appobject.Interactive('ys_stop_audio')
        // } catch (e) {
        //   //console.log(e)
        // }
        this.appFunction("ys_stop_audio");
    },
    methods: {
        play_audio (ask) {
            let _this = this;
            // let tempAside = document.getElementsByTagName('aside');
            // for (let i = 0, j = 0; i < tempAside.length; i++) {
            //   let a = tempAside[i].className;
            //   if (a === 'has-audio') {
            //     if (parseFloat(tempAside[i].style.width)) {
            //       window.playfinished();
            //       tempAside[i].style.width = 0 + 'px';
            //     }
            //   }
            // }
            if (!this.isPlay || !this.finish) {
                // let domId = localStorage.getItem('audio_storage');
                // let progress = document.getElementById(domId);
                window.playfinished();
            }
            this.isPlay = false;
            let progress = document.getElementById('audio_now' + this.ask.id);
            // localStorage.setItem('audio_storage', 'audio_now' + this.ask.id);
            // 如果没有时间  默认为0
            if (this.sid == '92') {
                if (ask.listen_duration < 0 || !ask.listen_duration) {
                    ask.duration = 1;
                } else {
                    this.allTime = ask.listen_duration;
                    ask.duration = ask.listen_duration;
                }
            } else {
                if (ask.duration < 0 || !ask.duration) {
                    ask.duration = 1
                } else {
                    this.allTime = ask.duration
                }
            }
            if (this.finish) {
                // try {
                //   // 播放
                //   appobject.Interactive("ys_start_audio," + ask.listen_audio);
                // } catch (e) {
                //   //console.log('开始播放')
                // }
                this.appFunction("ys_start_audio", ask.listen_audio);
            } else {
                // try {
                //   // 继续播放
                //   appobject.Interactive("ys_goon_audio");
                // } catch (e) {
                //   //console.log('继续播放')
                // }
                this.appFunction("ys_goon_audio");
            }
            this.speeds(ask.duration * 1000);
            window.playfinished = function () {
                _this.isPlay = true;
                _this.finish = true;
                _this.speed_time && clearInterval(_this.speed_time);
                _this.Speed = 1;
                _this.curTime = 0;
                progress.style.width = 0 + 'px';
                // try {
                //   appobject.Interactive('ys_stop_audio')
                // } catch (e) {
                //   //console.log('停止播放')
                // }
                _this.appFunction("ys_stop_audio");
            };
        },
        pause_audio () {
            this.isPlay = true;
            this.finish = false;
            this.speed_time && clearInterval(this.speed_time);
            // try {
            //   appobject.Interactive('ys_pause_audio')
            // } catch (e) {
            //   //console.log('暂停播放')
            // }
            this.appFunction("ys_pause_audio");
        },
        speeds (duration) {
            let _this = this;
            this.speed_time && clearTimeout(this.speed_time);
            this.speed_time = setInterval(() => {
                _this.curTime = (_this.Speed++) * 0.1;
            }, 100);
        },
    },
    created () {
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.audio-wrap {
    position: relative;
    height: 96px / $ppr;
    line-height: 96px / $ppr;
    padding: 0 24px / $ppr;
    i {
        display: block;
        position: absolute;
        top: 50%;
        left: 24px / $ppr;
        margin-top: -27px / $ppr;
        width: 54px / $ppr;
        height: 54px / $ppr;
        &.play {
            background: url("./img/play_audio.png") no-repeat;
            background-size: 100% 100%;
        }
        &.stop {
            background: url("./img/stop_audio.png") no-repeat;
            background-size: 100% 100%;
        }
    }
    .all-audio {
        position: absolute;
        top: 50%;
        left: 98px / $ppr;
        margin-top: -6px / $ppr;
        width: 524px / $ppr;
        height: 12px / $ppr;
        background: #c9c9c9;
        border-radius: 12px / $ppr;
    }
    .has-audio {
        display: block;
        position: absolute;
        top: 50%;
        left: 0;
        margin-top: -6px / $ppr;
        max-width: 100%;
        height: 12px / $ppr;
        background: #5e89ef;
        border-radius: 12px / $ppr;
    }
}
</style>
